import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import {  Autoplay , Navigation, Pagination , FreeMode, EffectFade, Controller } from 'swiper/modules';

function latestnews() {
    const latest_news_event_slider = document.querySelector('[data-target="latest_news_event_slider"]');
    if (!latest_news_event_slider) { return; }
    const latest_news_event_slider_pagination = latest_news_event_slider.querySelector('.swiper-pagination')

    const slider_events = new Swiper (latest_news_event_slider, {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 1,
    loop: true,
    effect:'fade',
    fadeEffect: {
        crossFade: true
      },
    // autoplay: {
    //     delay: 3000,
    // },
    speed: 1000,
    allowTouchMove: false,
    pagination: {
        el: latest_news_event_slider_pagination,
        clickable: true,
    },
       
    }); 
    
    const latest_news_tl_slider = document.querySelector('[data-target="latest_news_tl_slider"]');
    const latest_news_tl_slider_pagination = latest_news_tl_slider.querySelector('.swiper-pagination');

    const slider_tl = new Swiper(latest_news_tl_slider, {
        modules: [Navigation, Pagination, Autoplay, EffectFade, Controller], // Add Controller here
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // autoplay: {
        //     delay: 3000,
        // },
        speed: 1000,
        allowTouchMove: false,
        pagination: {
            el: latest_news_tl_slider_pagination,
            clickable: true,
        },
    });

    const latest_news_tl_slider_img = document.querySelector('[data-target="latest_news_tl_slider_img"]');

    const slider_tl_img = new Swiper(latest_news_tl_slider_img, {
        modules: [EffectFade, Controller, Autoplay], 
        slidesPerView: 1,
        loop: true,
        effect: 'fade',

        fadeEffect: {
            crossFade: false
        },
        // autoplay: {
        //     delay: 3000,
        // },
        speed: 1000,
        allowTouchMove: false, 
        pagination: false, 
    });

    
    slider_tl.controller.control = slider_tl_img;
    slider_tl_img.controller.control = slider_tl;



    
    const latest_box = document.querySelectorAll('[data-target="latest_box"]');
    const latest_box_wrap = document.querySelector('[data-target="latest_box_wrap"]');
    

    const tllatest = gsap.timeline({
        scrollTrigger: {
            trigger: latest_box_wrap,
            start: 'top bottom'
        }
    });

    tllatest.from(latest_box, {
        autoAlpha: 0,
        duration: 1,
        ease:'none',
        stagger: 0.2
    });



    
    
 
      
}


export { latestnews }; 